import * as React from "react";
import {getSingers} from "../http/singerApi";
import {getReportData, createReport, saveReport} from "../http/reportApi";
import PeriodChooser from "../components/PeriodChooser";
import Box from "@mui/material/Box";
import SingersAdder from "../components/SingersAdder";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import {json, useNavigate, useParams} from "react-router-dom";
import {LOGIN_ROUTE} from "../utils/constants";
import {observer} from "mobx-react-lite";
import {Context} from "../index";
import {DataGrid} from "@mui/x-data-grid";
import Container from "@mui/material/Container";

const Report = observer(() => {
    const colModel = {
        field: "",
        headerName: "",
        width: 200,
        editable: false,
        description: "",
        sortable: true,
    };

    const totalNames = {
        "income": "Доход САР",
        "minusSARTotal": "Расходы п.",
        "fiz_vat": "Налог с оборота",
        "lic_part": "Доля исполнителя (%)",
        "lic_income": "Доход исполнителя",
        "minusLICTotal": "Расходы п.",
        "fiz_ensurance": "Иные платежи в бюджет",
        "minus": "Вознаграждение правообладателя",
        "fiz_ndfl": "НДФЛ",
        "result": "К перечислению",
        "yur_vat": "Налог с оборота"
    };

    // const smallDigits = (val)=>{
    //     if(val){
    //         return (parseInt(val * 100) / 100);
    //     }
    //
    //     return 0;
    // }

    const smallDigits = (val) => {
        if (!val) return '0.00';

        // Округляем до 2 знаков и форматируем
        return (Math.floor(val * 100) / 100)
            .toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(",",".");
    };

    const [columns, setColumns] = React.useState([
        {
            ...colModel,
            field: "provider",
            headerName: "Контент-Провайдер",
            description: "Контент-Провайдер",
        },
        {
            ...colModel,
            field: "period",
            headerName: "Период",
            description: "Период",
        },
        {
            ...colModel,
            field: "songName",
            headerName: "Трек",
            description: "Трек",
        },
        {
            ...colModel,
            field: "singer",
            headerName: "Исполнитель",
            description: "Исполнитель",
        },
        {
            ...colModel,
            field: "platform",
            headerName: "Тип контента",
            description: "Тип контента",
        },
        {
            ...colModel,
            field: "downloads",
            headerName: "Количество скачиваний",
            description: "Количество скачиваний",
        },
        {
            ...colModel,
            field: "relatedContentCost",
            headerName: "Ст-ть ед. контента смежные",
            description: "Ст-ть ед. контента смежные",
        },
        {
            ...colModel,
            field: "authorContentCost",
            headerName: "Ст-ть ед. контента авторские",
            description: "Ст-ть ед. контента авторские",
        },
        {
            ...colModel,
            field: "relatedLicensePrize",
            headerName: "Вознаграждение Лицензиара смежные",
            description: "Вознаграждение Лицензиара смежные",
        },
        {
            ...colModel,
            field: "authorLicensePrize",
            headerName: "Вознаграждение Лицензиара авторские",
            description: "Вознаграждение Лицензиара авторские",
        },
    ]);
    const [data, setData] = React.useState([]);
    const [reportInfo, setReportInfo] = React.useState({});
    const {user} = React.useContext(Context);
    let {report} = useParams();

    const navigate = useNavigate();

    const getReport = async (reportId) => {
        try {
            const response = await getReportData(reportId);
            console.log(response);
            setReportInfo(response);
            setData(response.rows);
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }
    };

    const downloadReport = async () => {
        try {
            const response = await createReport(report);
            console.log(response);
            console.log(report);
            let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            var a = document.createElement('a');
            var blob = new Blob([response.data], {'type':contentType});
            a.href = window.URL.createObjectURL(response.data);
            a.download = report + "_report_" + (new Date().valueOf()) + ".xlsx";
            a.click();
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.clear();
                user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }
    }

    const saveReportHandle = async () => {
        try {
            const response = await saveReport(report);
            console.log(response);
            console.log(report);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.clear();
                user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }
    }

    React.useEffect(() => {
        // document.title = "Report";
        getReport(report);
    }, [report]);

    let totals = [];

    let infoResult = {};
    if(reportInfo.reportInfo?.result.length > 0){
        infoResult = JSON.parse(reportInfo.reportInfo.result);
    }

    if (reportInfo.reportInfo?.result.length > 0 || reportInfo.calculated?.related || reportInfo.calculated?.copyright) {
        let {related, copyright} = reportInfo.calculated;
        if(reportInfo.reportInfo.result.length > 0){
            related = infoResult.calculated.related;
            copyright = infoResult.calculated.copyright;
        }
        totals.push(<tr key={'tbl_title'}>
            <td></td>
            <td>Смежные права:</td>
            <td>Авторские права:</td>
        </tr>);

        let list = [];
        if(related.calculations?.length){
            list = related.calculations;
        } else if(copyright.calculations?.length){
            list = copyright.calculations;
        }

        for (const listKey in list) {
            let fieldName = totalNames[list[listKey][0]] || list[listKey][0];

            if(list[listKey][0] === "minusSARTotal"){
                fieldName = reportInfo["reportInfo"]["minusSARPunkt"];
            }
            if(list[listKey][0] === "minusLICTotal"){
                fieldName = reportInfo["reportInfo"]["minusLICPunkt"];
            }

            const relatedVal = related.calculations ? related.calculations[listKey][1] : 0;
            const copyrightVal = copyright.calculations ? copyright.calculations[listKey][1] : 0;

            if(list[listKey][0] === 'result'){
                totals.push(<tr key={'tbl_' + fieldName}>
                    <td>{fieldName}</td>
                    <td></td>
                    <td>{smallDigits(parseFloat(relatedVal) + parseFloat(copyrightVal))}</td>
                </tr>);
            } else {
                totals.push(<tr key={'tbl_' + fieldName}>
                    <td>{fieldName}</td>
                    <td>{smallDigits(relatedVal)}</td>
                    <td>{smallDigits(copyrightVal)}</td>
                </tr>);
            }
        }
    }

    const disabledFinalize = reportInfo.reportInfo?.result.length > 0;

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                marginTop: 20,
            }}
        >
            <Typography variant={'h5'}>Отчет</Typography>
            <Container maxWidth="xl">
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexDirection: "row",
                        marginBottom: 20,
                        boxSizing: 'padding-box'
                    }}
                >
                    <Button
                        type={'button'}
                        onClick={saveReportHandle}
                        // variant="contained"
                        variant="outlined"
                        color="success"
                        disabled={disabledFinalize}
                    >Финализировать</Button>
                    {reportInfo.reportInfo?.result.length > 0 ? <Button
                        type={'button'}
                        // onClick={downloadReport}
                        href={"/" + infoResult.filePath}
                        variant="contained"
                        color="info"
                    >Скачать XLSX</Button> : <Button
                        type={'button'}
                        onClick={downloadReport}
                        variant="contained"
                        color="info"
                    >Скачать XLSX</Button>}

                </div>
            </Container>
            {!disabledFinalize && data && columns && (
                <Container maxWidth="xl">
                    <Box sx={{height: "100%", width: "100%"}}>
                        <DataGrid
                            rows={data}
                            columns={columns}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 100,
                                    },
                                },
                            }}
                            pageSizeOptions={[10, 20, 50, 100]}
                            disableRowSelectionOnClick
                        />
                    </Box>
                </Container>
            )}
            <Box
                sx={{width: "100%"}}
                display="flex"
                flexDirection="row"
                justifyContent="flex-end"
                alignItems="flex-start"
                p={2}
            >
                <table className={'total_output'} key={'total_output'}>
                    <tbody>
                    {totals.map((row) => (row))}
                    </tbody>
                </table>
            </Box>
        </div>
    );
});

export default Report;
